import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  static targets = ["sortableList", "timeSummaryDisplay", "listContainer"];

  connect() {
    this.appendNewActivityForm = this.appendNewActivityForm.bind(this);
    this.refreshAfterUpdate    = this.refreshAfterUpdate.bind(this);
    this.expand                = this.expand.bind(this);
    this.collapse              = this.collapse.bind(this);
    App.Helpers.listenToCustomEvent(document, "card-list:inline-activity-form-close", this.refreshAfterUpdate);
    App.Helpers.listenToCustomEvent(document, "sortable-card-list-new-activity-form-fetch:success", this.appendNewActivityForm);
    App.Helpers.listenToCustomEvent(document, "sortable-list:expand", this.expand);
    App.Helpers.listenToCustomEvent(document, "sortable-list:collapse", this.collapse);
  }

  appendNewActivityForm(event) {
    const { html, listID } = event.detail;
    if (this.listID == listID) {
      App.Helpers.prependContent(this.sortableListTarget, html);
    }
  }

  refreshAfterUpdate(event) {
    const { listID } = event.detail;
    if (listID == this.listID && this.openFormCount === 0) {
      this.refreshList();
    }
  }

  refreshList(button) {
    App.Helpers.ajaxRequest({
      url:            this.refreshURL,
      successHandler: (response => this.updateList(response, button)).bind(this)
    });
  }

  updateList(response) {
    App.Helpers.replaceElement(this.element, response.html);
    document.dispatchEvent(createCustomEvent("card-lists:card-update", this.element));
  }

  expand(event) {
    const { containerID } = event.detail;
    if (containerID == this.containerID) {
      this.listContainerTarget.classList.remove("hidden-list")
    }
  }

  collapse(event) {
    const { containerID } = event.detail;
    if (containerID == this.containerID) {
      this.listContainerTarget.classList.add("hidden-list")
    }
  }

  //
  // GETTERS AND SETTERS
  //

  get listID() {
    return this.sortableListTarget.dataset.listId;
  }

  get refreshURL() {
    return this.data.get("refresh-url")
  }

  get openFormSelector() {
    return "form"
  }

  get openFormCount() {
    return [...this.element.querySelectorAll(this.openFormSelector)].length;
  }

  get containerID() {
    return this.data.get("container-id")
  }
}



// WEBPACK FOOTER //
// ./app/components/card_lists/assets/javascript/card-lists-sortable-card-controller.js